// import { Alert } from "react";
import Alert from 'sweetalert2'
import jwt from 'jwt-decode'
import localStorageCustom from './localStorage'
const regexValidaCorreo = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,6}\b$/i;
const regexValidaOnlyText = /[A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff]+/g;

function val_isEmail(value) {
  let regex = new RegExp(regexValidaCorreo);
  return regex.test(value);
}

function val_isEmpty(value = "") {
  let estado = true;
  if (value)
    if (value.toString().trim() != "") {
      estado = false;
    }
  return estado;
}

function val_onlyLetter(value) {
  let regex = new RegExp(regexValidaOnlyText);
  return regex.test(value);
}

function parseIntEmpty(value = "") {
  if (value === "" || value === NaN) return 0;
  else return parseInt(value);
}

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, "g"), replace);
}
async function notificacion(
  titulo = "Ups... La aplicación no responde",
  mensaje = "Inténtalo de nuevo. Si el problema persiste intenta más tarde.",
  fn_caseIsOk = null
) {

  await Alert.fire({
    title: titulo,
    html: mensaje,
    // icon: 'warning',
    showCancelButton: false,
    confirmButtonText: 'Aceptar',
    allowOutsideClick: false
  })
    .then((result) => {
      if (result.value) {
        if (fn_caseIsOk != null) fn_caseIsOk();
      }
    });
  // await Alert.fire(
  //   titulo,
  //   mensaje,
  //   [
  //     {
  //       text: "Aceptar",
  //       onPress: () => {
  //         if (fn_caseIsOk) {
  //           fn_caseIsOk();
  //         }
  //       },
  //     },
  //   ],
  //   { cancelable: false }
  // );
}

function prepareNumber(value = 0) {
  if (value == "" || value == undefined || value == null) value = 0;

  if (typeof Number(value) != "number") {
    value = 0;
  }
  return value;
}

function prepareDataTag(tagParam, value) {
  return { tagParam, value }
}

function truncate(text, n) {
  return text.substr(0, n - 1) + (text.length > n ? '...' : '');
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

async function askNotificacion(titulo, mensaje, fn_accept) {
  await Alert.fire({
    title: titulo,
    text: mensaje,
    // icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Si',
    cancelButtonText: 'No'
  })
    .then((result) => {
      if (result.value) {
        if (fn_accept != null) fn_accept();
      }
    });
}

const validateTokenExpired = () => {
  let token = localStorageCustom.prototype.getToken();
  let dataToken = jwt(token);
  let timeSpan = (dataToken.nbf * 1000);
  let fechaExpired = new Date(timeSpan);
  let fechaExpiredUpdate = new Date(fechaExpired.setDate(fechaExpired.getDate() + 1));

  let tokenIsValid = !(new Date() > fechaExpired);
  console.log(fechaExpiredUpdate);
  console.log(new Date());
  console.log(tokenIsValid);

  return dataToken;
}

function numberWithCommas(number2) {
  if (number2) {
    // console.log("numberWithCommas", number2);
    number2 = number2.toFixed((/\./g.test(number2)) ? 2 : 0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
  }

  if (!number2.toString().includes(".")) {
    number2 += ".00";
  }

  return number2;
}

function getStatePage(history) {  
  const { pathname } = history.location;
  var isLoggedIn = localStorageCustom.prototype.getToken() ? true : false;
  return isLoggedIn;
  // if (!isLoggedIn && pathname != "/") {
  //   window.location.href = "/";
  // }
  // else
  //   return null;
}

export {
  val_isEmail,
  val_isEmpty,
  replaceAll,
  notificacion,
  prepareNumber,
  parseIntEmpty,
  prepareDataTag,
  truncate,
  onlyUnique,
  askNotificacion,
  val_onlyLetter,
  numberWithCommas,
  validateTokenExpired,
  getStatePage
};